import { render } from "./Switch.vue?vue&type=template&id=1b185af3&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1b185af3"

export default script